import { useObserver, useSubtree } from "subtree.js/react";
import { BackButton, OnboardingLayout } from "../../components/onboarding/OnboardingLayout";
import type { SellingPath } from "../../core/primitives/onboarding";
import { OnboardingSellingActions, OnboardingSellingState } from "./onboarding-selling-model";

const CHOICES: { path: SellingPath; title: string; detail: string }[] = [
  {
    path: "shows",
    title: "At card shows",
    detail: "Take card payments at your table. Add the table you booked, or book one now.",
  },
  {
    path: "shop",
    title: "In my own shop",
    detail: "Take payments at your counter, and put your shop on the map for walk-in customers.",
  },
];

export function OnboardingSellingPage() {
  const state = useSubtree(OnboardingSellingState);
  const actions = useSubtree(OnboardingSellingActions);
  const observer = useObserver();
  const storeId = observer.watch(state.storeId) ?? undefined;
  const picked = observer.watch(state.path);

  return (
    <OnboardingLayout
      step="selling"
      title="Where do you sell?"
      description="Pick one to get started. Do both? Add the other any time in Settings."
      storeId={storeId}
      footer={<BackButton onClick={actions.back} />}
    >
      <ul className="flex flex-col gap-2.5">
        {CHOICES.map((choice) => (
          <li key={choice.path}>
            <button
              type="button"
              onClick={() => actions.choose(choice.path)}
              className={`w-full rounded-row border px-3.5 py-3 text-left transition-colors hover:border-accent ${
                picked === choice.path ? "border-accent" : "border-line"
              }`}
            >
              <p className="text-[13px] font-medium text-white">{choice.title}</p>
              <p className="mt-0.5 text-xs leading-snug text-muted">{choice.detail}</p>
            </button>
          </li>
        ))}
      </ul>
    </OnboardingLayout>
  );
}
